import { computed, inject } from '@angular/core';
import { signalStore, withState, withMethods, withHooks, withComputed } from '@ngrx/signals';
import { AuthService } from './auth.service';
import { AuthStatus } from '../models/auth-status.model';
import { patchState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { AppRole } from '../models/app-role.enum';

type AuthState = {
  status: AuthStatus | null;
  isLoading: boolean;
  error: string | null;
};

const initialState: AuthState = {
  status: null,
  isLoading: false,
  error: null,
};

export const AuthStore = signalStore(
  withState(initialState),
  withMethods((store, authService = inject(AuthService)) => ({
    load: rxMethod<void>(
      pipe(
        tap(() => patchState(store, { isLoading: true, error: null })),
        switchMap(() => authService.getAuthStatus()),
        tapResponse({
          next: (authStatus) => {
            patchState(store, { status: authStatus, isLoading: false, error: null });
          },
          error: (error: HttpErrorResponse) => {
            patchState(store, { status: null, isLoading: false, error: error.error });
          },
        }),
      ),
    ),
    logout(): void {
      authService.logout();
    },
  })),
  withComputed((store) => ({
    hasInvoicingAccess: computed(
      () =>
        (store.status()?.roles?.includes(AppRole.InvoiceManager) ||
          store.status()?.roles?.includes(AppRole.Admin)) ??
        false,
    ),
    hasDataAccess: computed(
      () =>
        (store.status()?.roles?.includes(AppRole.PartnerDataManager) ||
          store.status()?.roles?.includes(AppRole.Admin)) ??
        false,
    ),
    hasIntegrationAccess: computed(
      () =>
        (store.status()?.roles?.includes(AppRole.IntegrationManager) ||
          store.status()?.roles?.includes(AppRole.Admin)) ??
        false,
    ),
    countryAccess: computed(() => store.status()?.countryAccess ?? []),
  })),
  withHooks((store) => ({
    onInit: () => {
      store.load();
    },
  })),
);
